export class LoginModel {
    email: string;
    password: string;
    rememberMe: boolean;
    returnUrl: string | (string | null)[];

    constructor(email: string, password: string, rememberMe: boolean, returnUrl: string | (string | null)[]) {
        this.email = email;
        this.password = password;
        this.rememberMe = rememberMe;
        this.returnUrl = returnUrl;
    }
}
